export default function getInitTime() {
    if (!window.performance && !window.performance.timeOrigin) {
        throw new Error('Performance value not set');
    }
    return window.performance.timeOrigin;
}
